import { render, staticRenderFns } from "./Subventions.vue?vue&type=template&id=1dac2209&"
import script from "./Subventions.vue?vue&type=script&lang=js&"
export * from "./Subventions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports